import {
    Card,
    CardContent,
    CardHeader,
    makeStyles,
} from "@material-ui/core";
import { useTheme } from "@mui/material";
import Chart from "react-apexcharts";

type Props = {
    series: number[];
    labels: string[];
    title: string;
    subtitle?: string;
};

const useStyles = makeStyles((theme) => ({
    card: {
        height: "100%",
        borderRadius: 12,
        border: `1px solid ${theme.palette.divider}`,
    },
    chartWrap: {
        minHeight: 320,
    },
}));

const Donut = ({ series, labels, title, subtitle }: Props) => {
    const theme = useTheme();
    const classes = useStyles();
    const hasData = series.some((v) => v > 0);

    return (
        <Card className={classes.card} elevation={0}>
            <CardHeader
                title={title}
                subheader={subtitle}
                titleTypographyProps={{ variant: "h6" }}
            />
            <CardContent className={classes.chartWrap}>
                <Chart
                    height="300"
                    options={{
                        labels,
                        chart: { toolbar: { show: false } },
                        plotOptions: {
                            pie: {
                                expandOnClick: false,
                                donut: { size: "58%", labels: { show: true } },
                            },
                        },
                        colors: [
                            "#fcca4a",
                            "#2e7d32",
                            "#2196f3",
                            "#ff9800",
                            "#424242",
                            "#9e9e9e",
                        ],
                        dataLabels: {
                            enabled: hasData,
                            style: {
                                fontSize: "12px",
                                fontWeight: 600,
                                colors: ["#ffffff"],
                            },
                        },
                        legend: {
                            show: true,
                            position: "bottom",
                            labels: { colors: theme.palette.text.primary },
                        },
                        noData: {
                            text: "No data for this period",
                            align: "center",
                            verticalAlign: "middle",
                        },
                    }}
                    series={hasData ? series : []}
                    type="donut"
                />
            </CardContent>
        </Card>
    );
};

export default Donut;
